"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBoundaryBaseSchema = void 0;
const zod_1 = require("zod");
const BoundaryAssertionStrength_1 = require("../BoundaryAssertionStrength");
const BoundaryLevel_1 = require("../BoundaryLevel");
const BoundaryTarget_1 = require("../BoundaryTarget");
exports.IBoundaryBaseSchema = zod_1.z.object({
    strength: BoundaryAssertionStrength_1.BoundaryAssertionStrengthSchema.optional(),
    target: BoundaryTarget_1.BoundaryTargetSchema,
    level: BoundaryLevel_1.BoundaryLevelSchema.optional(),
    relative_to: BoundaryTarget_1.BoundaryTargetSchema.optional(),
    class: zod_1.z.string().optional(),
});
//# sourceMappingURL=IBoundaryBase.js.map